import { http } from './index'
import appInstance from '../main'
// @ts-check
/**
 * @typedef {Object} TFileSearchBase
 * @property {string} fu_origin_filename 文件夹名称
 * @property {number} fb_subject_id 音乐科目（1）或者美术科目（2）
 * @property {number} page 页码
 * @property {number} page_size 条数
 * @property {number} [is_public] 是否公开
 */

/**
 * @typedef {Object} getStorageFolderPms
 * @property {string} fb_publisher_id 出版社id
 * @property {string} fb_textbook_id 所属教材id
 * @property {string} fb_dict_id 文件夹属于教材哪个目录的id
 * @property {number} fb_file_type 文件类型
 * @property {number} fb_scope_type 资源范围
 */

/**
 * @typedef {Object} Tlinks
 * @property {string | null} first
 * @property {string | null} last
 * @property {string | null} next
 * @property {string | null} prev
 */

/**
 * @typedef {Object} Tmeta
 * @property {number} current_page
 * @property {number} from
 * @property {number} last_page
 * @property {Array<any>} links
 * @property {string} path
 * @property {number} per_page
 * @property {number} to
 * @property {number} total 总条数
 */

/**
 * @template T
 * @typedef {Object} TCbResoult
 * @property {T} data
 * @property {Tlinks} links
 * @property {Tmeta} meta
 */

/**
 * @typedef {Object} getStorageFolderNumberCb
 * @property {number} file_type 文件夹类型
 *  - `0` ？？
 *  - `1` 图片
 *  - `2` 音频
 *  - `3` 视频
 * @property {number} number
 */

/**
 * @typedef {Object} getFileStorageCb
 * @property {Array<any>} data
 * @property {Tlinks} links
 * @property {Tmeta} meta
 */

/**
 * @typedef {Object} TfileStoragePms
 * @property {number} fb_file_type 文件类型
 * @property {number} fb_scope_type
 * @property {string} fu_origin_filename 文件名称
 * @property {number} fb_subject_id 音乐科目（1）或者美术科目（2）
 * @property {number} page 页码
 * @property {number} page_size 条数
 * @property {number} folder_id 文件夹id
 */

/**
 * @typedef {Object} Publisher
 * @property {number} id
 * @property {string} name 出版社名称
 * @property {string} pinyin_prefix
 * @property {string} created_at
 * @property {string} updated_at
 * @property {string} deleted_at
 * @property {number} is_primary 是否为小学
 * @property {number} is_middle 是否为初中
 * @property {number} is_high 是否为高中
 * @property {number} subject_id 科目id
 */

/**
 * 获取不同类型（图片、音频、视频）的资源
 * @param {TFileSearchBase & getStorageFolderPms} pms
 * @returns {Promise<TCbResoult<Array<any>>>}
 */
export const getStorageFolder = (pms) => {
  return http({
    url: '/api/edu/file-storage',
    method: 'get',
    params: pms
  })
}

/**
 * 获取不同文件类型的数量
 * @param {TFileSearchBase} pms
 * @returns {Promise<getStorageFolderNumberCb[]>}>}
 */
export const getStorageFolderNumber = (pms) => {
  return http({
    url: '/api/edu/file-storage/number',
    method: 'get',
    params: {
      ...pms
    }
  })
}


/**
 * 获取文件夹中的文件
 * @param {TfileStoragePms} pms
 * @returns {Promise<getFileStorageCb>}
 */
export const getFileStorage = (pms) => {
  return http({
    url: '/api/edu/file-storage',
    method: 'get',
    params: pms
  })
}

/**
 * 获取云盘空间
 * @param {*} pms
 * @returns
 */
export const getDiskSpace = (pms) => {
  return http({
    url: '/api/disk-sapce',
    method: 'get',
    params: pms
  })
}

/**
 * 根据 id 查询教材信息
 * @param {String | Number} id
 * @returns
 */
export const getTextbooksById = (id) => {
  return http({
    url: `/api/textbooks/${id}`,
    method: 'get',
  })
}

/**
 * 素材库创建素材接口 或者 创建文件夹
 * @param {Object} data
 * @returns
 */
export const postFileStorage = (data) => {
  return http({
    url: `/api/file-storage`,
    method: 'post',
    data
  })
}

/**
 * 素材库删除素材接口 或者 删除文件夹
 * @param {Array<number>} ids
 * @returns
 */
export const deleteResource = (ids) => {
  return http({
    url: `/api/file-storage`,
    method: 'delete',
    data: {
      ids
    }
  })
}

/**
 * 重命名资源或者文件夹
 * @param {number} id 资源或文件夹id
 * @param {string} name 新名称
 * @returns
 */
export const renameResourceOrFolder = (id, name) => {
  return http({
    url: `/api/file-storage/${id}/rename`,
    method: 'PUT',
    data: {
      name
    }
  })
}

/**
 * 移动资源到文件夹
 * @param {Array<number>} ids 移动的资源id
 * @param {number} folder_id 移动到的文件夹id
 * @returns
 */
export const moveResourceToFolder = (ids, folder_id) => {
  return http({
    url: `/api/edu/file-storage-move`,
    method: 'PUT',
    data: {
      folder_id,
      ids
    }
  })
}

/**
 * 根据学段获取对应学段的出版社
 * @returns {Promise<TCbResoult<Publisher[]>>}
 */
export const getSwitchTextbook = () => {
  return appInstance.$api.question_set.getPublisherId({
    fb_subject_id: appInstance.$route.query.subjectId
  })
}

/**
 * 根据 学段 + 出版社id 获取对应当前出版社学段下的教材
 */
export const getTextbooksByPublisherIdAndSchoolStage = ({fb_publisher_id, school_stage}) => {
  return appInstance.$api.resource.getTextbooks({
    fb_subject_id: appInstance.$route.query.subjectId,
    fb_publisher_id,
    school_stage,
    // 书荣 笃定 教材就是看到全部的，不缺分自有、平台、教师
    // scope_type: this.scope_type,
    scope_type: 0,
    page_size: 998,
    page: 1
  })
}
